/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { MiButtonOptions } from '@/components/MiButton/MiButton';
import { MiFormField } from '@/components/MiForm/MiForm';
import { MiDialogOptions } from '@/components/MiDialog/MiDialog';
import { User } from '@/models/User';

@Component<ForgotPassword>({})
export default class ForgotPassword extends Vue {
  protected $pageTitle = 'wachtwoord instellen';
  protected passwordReset = false;

  protected token: string | null = null;

  protected email: string | null = null;

  protected password = '';

  protected password_confirmation = '';


  protected mounted(): void {
    this.token = this.$route.query.token as string;
    this.email = this.$route.query.email as string;
  }

  protected handleFieldChanged(field: MiFormField) {
    (this as any)[field.key] = field.value;
  }

  protected get canSubmit(): boolean {
    return !!(this.password.length
      && this.password_confirmation.length
      && this.password === this.password_confirmation);
  }

  protected async resetPassword(): Promise<void> {
    if (! this.password
      || !this.password_confirmation
    ) {
      this.$store.dispatch('openDialog', this.resetErrorDialog);
      return;
    }

    const user = this.$store.state.Auth;

    const payload = {
      password: this.password,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      uuid: user.uuid,
      force_password_change: false
    };

    new User(user)
    .update(payload)
    .then((response: AxiosResponse) => {
      this.$store.dispatch('userAuthenticated', response);
      this.$router.push('/');
    })
    .catch((error: AxiosError) => {
      ErrorHandler.alert('The password and password confirmation should be the same.', 'Missmatching passwords');
    })
  }

  protected get title(): string {
    return this.passwordReset
      ? 'Wachtwoord aangepast!'
      : 'Wachwoord resetten';
  }

  protected get text(): string {
    return this.passwordReset
      ? 'Je wachtwoord is aangepast, je kunt nu inloggen met je nieuwe wachtwoord.'
      : 'Vul hieronder je een nieuw wacthwoord in';
  }

  protected get resetErrorDialog(): MiDialogOptions {
    return {
      title: 'Wachtwoord niet aangepast',
      text: 'We konden je wachtwoord niet aanpassen. Probeer het nogmaals via de link in de e-mail, of vraag een nieuwe wachtwoord reset aan.',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Sluiten',
          action: () => {
            this.$store.dispatch('closeDialog');
          },
        },
      },
    };
  }

  protected get buttonOptions(): MiButtonOptions {
    return {
      color: 'secondary',
      colorIntensity: 700,
      round: true,
      flat: true,
      label: 'terug naar Login',
      to: '/login'
    };
  }
}
